import React, {useEffect, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import lottie from 'lottie-web'
import animationData from '../../../../media/auth/loader-anim.json'
import { useIntl } from 'react-intl'

const SwitchingCompany = ({isActive, setIsActive,props}: any) => {
  const {formatMessage} = useIntl()

  const Lottie = ({animationData}: any) => {
  const containerRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
      const animation = lottie.loadAnimation({
        container: containerRef.current as Element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData,
      })

      // Cleanup animation on component unmount
      return () => {
        animation.destroy()
      }
    }, [animationData])

    return <div ref={containerRef} style={{width: '250px', height: '250px', margin: 'auto'}}></div>
  }
  return (
    <div>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
        {...props}
        size='md'
        backdrop='static'  
        keyboard={false} 
      >
        <Modal.Body>
          <div className='container text-center' style={{padding:'24px'}}>
            <Lottie animationData={animationData} className='mb-4'/>
            <div>
              <h1 className='font-size-16 mb-2'>{formatMessage({id: 'Switching Company'})}</h1>
              <p className='m-0'>{formatMessage({id: 'Please wait while we switch you to your other company'})}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default SwitchingCompany
